/* eslint-disable no-undef */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import initWeixin from '../util/wx-share.js'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'h5public-list',
    component: () => import(/* webpackChunkName: "h5public-list" */ '../H5pages/publicList.vue')
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "pcIndex" */ '../pages/pcIndex.vue'),
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "index" */ '../pages/index.vue')
      },
      {
        path: '/privacy',
        name: 'privacy',
        component: () => import(/* webpackChunkName: "privacy" */ '../pages/privacy.vue')
      }
      // 0725屏蔽
      // {
      //   path: '/help',
      //   name: 'faq',
      //   component: () => import(/* webpackChunkName: "privacy" */ '../pages/faq.vue')
      // }
    ]
  },
  // 0725添加
  {
    path: '/help',
    name: 'faq',
    // component: () => import(/* webpackChunkName: "privacy" */ '../pages/faq.vue')
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/download.vue')
  },
  //
  {
    path: '/h5detail',
    name: 'h5detail',
    component: () => import(/* webpackChunkName: "h5detail" */ '../H5pages/detail.vue')
  },
  {
    path: '/h5download',
    name: 'h5download',
    meta: {
      title: '环保小智下载'
    },
    component: () => import(/* webpackChunkName: "h5download" */ '../H5pages/download.vue')
  },
  {
    path: '/h5support',
    name: 'h5support',
    meta: {
      title: '获取技术支持'
    },
    component: () => import(/* webpackChunkName: "h5support" */ '../H5pages/support.vue')
  },
  {
    path: '/h5vote',
    name: 'h5vote',
    meta: {
      title: '优秀企业评选'
    },
    component: () => import(/* webpackChunkName: "h5download" */ '../H5pages/vote.vue')
  },
  {
    path: '/h5vote-detail',
    name: 'h5vote-detail',
    component: () => import(/* webpackChunkName: "h5vote-detail" */ '../H5pages/voteDetail.vue')
  },
  {
    path: '/h5vote-apply',
    name: 'h5vote-apply',
    component: () => import(/* webpackChunkName: "h5vote-apply" */ '../H5pages/voteApply.vue')
  },
  {
    path: '/h5agreement',
    name: 'h5agreement',
    component: () => import(/* webpackChunkName: "h5agreement" */ '../H5pages/agreement.vue')
  },
  {
    path: '/h5privacy',
    name: 'h5privacy',
    component: () => import(/* webpackChunkName: "h5privacy" */ '../H5pages/privacy.vue')
  },
  {
    path: '/h5qq-qrcode',
    name: 'h5qq-qrcode',
    component: () => import(/* webpackChunkName: "h5qq-qrcode" */ '../H5pages/qqQrcode.vue')
  },
  {
    path: '/h5public-detail',
    name: 'h5public-detail',
    component: () => import(/* webpackChunkName: "h5public-detail" */ '../H5pages/publicDetail.vue')
  },
  {
    path: '/h5public-list',
    name: 'h5public-list',
    component: () => import(/* webpackChunkName: "h5public-list" */ '../H5pages/publicList.vue')
  },
  {
    path: '/h5ehsPublic-detail',
    name: 'h5ehsPublic-detail',
    component: () => import(/* webpackChunkName: "h5ehsPublic-detail" */ '../H5pages/ehsPublicDetail.vue')
  },
  {
    path: '/h5public-search',
    name: 'h5public-search',
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/publicSearch.vue')
  },
  {
    path: '/h5public-page',
    name: 'h5public-page',
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/PublicPage.vue')
  },
  {
    path: '/h5Live-list',
    name: 'h5Live-list',
    component: () => import(/* webpackChunkName: "h5Live-list" */ '../H5pages/LiveBroadcast.vue')
  },
  {
    path: '/h5Live-detail',
    name: 'h5Live-detail',
    component: () => import(/* webpackChunkName: "h5Live-detail" */ '../H5pages/livePlayer.vue')
  },
  {
    path: '/h5EHS-ehsHome',
    name: 'h5EHS-ehsHome',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehs-com/ehsEnQltyMnt.vue')
  },
  {
    path: '/h5Comment-detail',
    name: 'h5Comment-detail',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/h5CommentInfo.vue')
  },
  {
    path: '/h5RechargePage-detail',
    name: 'h5RechargePage-detail',
    component: () => import(/* webpackChunkName: "h5RechargePage-detail" */ '../H5pages/h5RechargePage.vue')
  },
  {
    path: '/h5RechargePageA-detail',
    name: 'h5RechargePageA-detail',
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/h5RechargePageA.vue')
  },
  {
    path: '/H5SearchPage',
    name: 'H5SearchPage',
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/H5SearchPage.vue')
  },
  {
    path: '/h5EIANFAQ',
    name: 'h5EIANFAQ',
    component: () => import(/* webpackChunkName: "h5EIANFAQ" */ '../H5pages/eianFAQ.vue')
  },
  {
    path: '/h5QueAns',
    name: 'h5QueAns',
    component: () => import(/* webpackChunkName: "h5EIANFAQ" */ '../H5pages/xzQueAns.vue')
  },
  {
    path: '*',
    meta: { showBack: false },
    redirect: '/'
  },
  // 环保管家
  {
    path: '/ehsManagement',
    name: 'ehsManagement',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsManagement.vue')
  },
  {
    path: '/ehsInvestigation',
    name: 'ehsInvestigation',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsInvestigation.vue')
  },
  {
    path: '/ehsSoilWater',
    name: 'ehsSoilWater',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsSoilWater.vue')
  },
  {
    path: '/ehsProfile',
    name: 'ehsProfile',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsProfile.vue')
  },
  {
    path: '/ehsEia',
    name: 'ehsEia',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsEia.vue')
  },
  {
    path: '/ehsFieldTone',
    name: 'ehsFieldTone',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsFieldTone.vue')
  },
  {
    path: '/ehsEnvSup',
    name: 'ehsEnvSup',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsEnvSup.vue')
  },
  {
    path: '/ehsEmePlan',
    name: 'ehsEmePlan',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsEmePlan.vue')
  },
  {
    path: '/ehsBloPermit',
    name: 'ehsBloPermit',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsBloPermit.vue')
  },
  {
    path: '/ehsDesign',
    name: 'ehsDesign',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsDesign.vue')
  },
  {
    path: '/ehsCheck',
    name: 'ehsCheck',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsCheck.vue')
  },
  {
    path: '/ehsTaxGas',
    name: 'ehsTaxGas',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsTaxGas.vue')
  },
  {
    path: '/ehsTaxWater',
    name: 'ehsTaxWater',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsTaxWater.vue')
  },
  {
    path: '/ehsSoilCheck',
    name: 'ehsSoilCheck',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsSoilCheck.vue')
  },
  {
    path: '/ehsGroWatCheck',
    name: 'ehsGroWatCheck',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsGroWatCheck.vue')
  },
  {
    path: '/ehsSiteResCheck',
    name: 'ehsSiteResCheck',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsSiteResCheck.vue')
  },
  {
    path: '/ehsOtherCheck',
    name: 'ehsOtherCheck',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsOtherCheck.vue')
  },
  {
    path: '/ehsLocalDep',
    name: 'ehsLocalDep',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsLocalDep.vue')
  },
  {
    path: '/ehsSuperCenter',
    name: 'ehsSuperCenter',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsSuperCenter.vue')
  },
  {
    path: '/ehsSelfIns',
    name: 'ehsSelfIns',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsSelfIns.vue')
  },
  {
    path: '/ehsHandover',
    name: 'ehsHandover',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsHandover.vue')
  },
  {
    path: '/ehsInspection',
    name: 'ehsInspection',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsInspection.vue')
  },
  {
    path: '/ehsHidProject',
    name: 'ehsHidProject',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsHidProject.vue')
  },
  {
    path: '/ehsTimedMsg',
    name: 'ehsTimedMsg',
    component: () => import(/* webpackChunkName: "h5Comment-detail" */ '../H5pages/ehsPage-com/ehsTimedMsg.vue')
  },
  // 230216
  {
    path: '/ehsAnnualReport',
    name: 'ehsAnnualReport',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsAnnualReport.vue')
  },
  {
    path: '/ehsMonitorPlan',
    name: 'ehsMonitorPlan',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsMonitorPlan.vue')
  },
  {
    path: '/ehsGasMonitor',
    name: 'ehsGasMonitor',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsGasMonitor.vue')
  },
  {
    path: '/ehsWaterMonitor',
    name: 'ehsWaterMonitor',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsWaterMonitor.vue')
  },
  {
    path: '/ehsNoiseMonResult',
    name: 'ehsNoiseMonResult',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsNoiseMonResult.vue')
  },
  {
    path: '/ehsFixedMonitor',
    name: 'ehsFixedMonitor',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsFixedMonitor.vue')
  },
  {
    path: '/ehsQuaMonResult',
    name: 'ehsQuaMonResult',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsQuaMonResult.vue')
  },
  {
    path: '/ehsLDARTest',
    name: 'ehsLDARTest',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsLDARTest.vue')
  },
  {
    path: '/ehsHazWaste',
    name: 'ehsHazWaste',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsHazWaste.vue')
  },
  {
    path: '/ehsHazWasLabel',
    name: 'ehsHazWasLabel',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsHazWasLabel.vue')
  },
  {
    path: '/ehsHazWasSave',
    name: 'ehsHazWasSave',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsHazWasSave.vue')
  },
  {
    path: '/ehsHazWasPlan',
    name: 'ehsHazWasPlan',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsHazWasPlan.vue')
  },
  {
    path: '/ehsHazWasHis',
    name: 'ehsHazWasHis',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsHazWasHis.vue')
  },
  {
    path: '/ehsHazWasInd',
    name: 'ehsHazWasInd',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsHazWasInd.vue')
  },
  {
    path: '/ehsGasBook',
    name: 'ehsGasBook',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsGasBook.vue')
  },
  {
    path: '/ehsWaterBook',
    name: 'ehsWaterBook',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsWaterBook.vue')
  },
  {
    path: '/ehsFixedBook',
    name: 'ehsFixedBook',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsFixedBook.vue')
  },
  {
    path: '/ehsLifeJunk',
    name: 'ehsLifeJunk',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsLifeJunk.vue')
  },
  {
    path: '/ehsPersonnel',
    name: 'ehsPersonnel',
    component: () => import(/* webpackChunkName: "h5EHS-ehsHome" */ '../H5pages/ehsPage-com/ehsPersonnel.vue')
  },
  {
    path: '/ehsMenuPage',
    name: 'h5MenuPage',
    meta: {
      title: '环保管家主菜单'
    },
    component: () => import(/* webpackChunkName: "h5download" */ '../H5pages/ehsPage-com/ehsMenuPage.vue')
  },
  {
    path: '/h5ComFAQ',
    name: 'h5ComFAQ',
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/h5ComFAQ.vue')
  },
  {
    path: '/h5Label',
    name: 'h5Label',
    meta: {
      title: '二维码详情'
    },
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/h5Label.vue')
  },
  {
    path: '/h5Eng',
    name: 'h5Eng',
    meta: {
      title: '二维码详情'
    },
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/h5Eng.vue')
  },
  {
    path: '/h5LabelSamp',
    name: 'h5LabelSamp',
    meta: {
      title: '原始记录二维码详情'
    },
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/h5LabelSamp.vue')
  },
  {
    path: '/h5FAQ',
    name: 'h5FAQ',
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/h5FAQ.vue')
  },
  {
    path: '/h5IsoPainter',
    name: 'h5IsoPainter',
    meta: {
      title: '等值线图绘制器'
    },
    component: () => import(/* webpackChunkName: "h5RechargePageA-detail" */ '../H5pages/h5IsoPainter.vue')
  },
  // 鸿蒙手机跳转网页文件
  {
    path: '/openFile',
    name: 'openFile',
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/openFile.vue')
  },
  // 个人中心
  {
    path: '/h5public-personal',
    name: 'h5public-personal',
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/perCenterPage.vue')
  },
  // 环评审核
  {
    path: '/h5public-eiaExamine',
    name: 'h5public-eiaExamine',
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/eiaExamine.vue')
  },
  {
    path: '/eiaExamineForApp',
    name: 'eiaExamineForApp',
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/eiaExamineForApp.vue')
  },
  // 在线评估
  {
    path: '/coeHome',
    name: 'coeHome',
    meta: {
      title: '在线评估'
    },
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/coe-com/coeHome.vue')
  },
  // 分享 单位排行
  {
    path: '/unitRanking',
    name: 'unitRanking',
    meta: {
      title: '单位排行'
    },
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/appShareDtl-com/unitRanking.vue')
  },
  // 分享 小智问答
  {
    path: '/chatAutoAnswer',
    name: 'chatAutoAnswer',
    meta: {
      title: '小智问答分享'
    },
    component: () => import(/* webpackChunkName: "h5public-search" */ '../H5pages/appShareDtl-com/chatAutoAnswer.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.afterEach((to, from) => {
  if (from.query.token) {
    sessionStorage.setItem('qs_token', from.query.token)
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  /* // 这里进行微信分享设置
  initWeixin().then(res => {
    if (res === 'success') {
      wx.onMenuShareTimeline({
        title: '我是设置的title', // 分享标题
        link: 'http://qs.qsyhbgj.com', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://www.baidu.com/s?wd=react&usm=1&ie=utf-8&rsv_cq=&rsv_dl=0_right_recommends_merge_21102&euri=fda4d574cbe749ce83bc3d96a8ea5f7e', // 分享图标
        success: function () {
          console.log('success朋友圈')
        },
        fail: function (err) {
          console.log('fail1', err)
        }
      })
      wx.updateTimelineShareData({
        title: '我是设置的title', // 分享标题
        desc: '我是设置的描述', // 分享描述
        link: 'http://qs.qsyhbgj.com', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://www.baidu.com/s?wd=react&usm=1&ie=utf-8&rsv_cq=&rsv_dl=0_right_recommends_merge_21102&euri=fda4d574cbe749ce83bc3d96a8ea5f7e', // 分享图标
        success: function () {
          // 设置成功
          console.log('success--update朋友圈')
        },
        fail: function (err) {
          console.log('fail3', err)
        }
      })
      wx.checkJsApi({
        jsApiList: ['onMenuShareTimeline', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: (res) => {
          console.log('success--check', res)
        },
        fail: function (err) {
          console.log('fail', err)
        }
      })
    } else {
      console.log('微信初始化失败')
    }
  }) */
})

export default router
